import {
  IPCEventTypeToInferredPayloadMap,
  ipcEventTypeToPayloadMap,
} from './ipc.payload-maps';
import { IPCEventType } from './ipc.types';

export const validateContextKitResponse = <
  T extends IPCEventType | string,
  R = T extends IPCEventType ? IPCEventTypeToInferredPayloadMap[T] : unknown,
>(
  method: T,
  data: unknown
): R => {
  // Only validate if T is IPCEventType
  if (typeof method === 'string' && method.includes(':')) {
    const schema = ipcEventTypeToPayloadMap[method as IPCEventType];

    if (!schema) {
      // If no schema is defined, return data as-is (for events with null payloads)
      return data as R;
    }

    try {
      const validatedData = schema.parse(data);
      return validatedData as R;
    } catch (error) {
      console.error('Electron-Validation Error', method, error);
      throw new Error(
        `Validation failed for ${method}: ${error instanceof Error ? error.message : String(error)}`
      );
    }
  }

  // For non-IPCEventType strings, return data as-is
  return data as R;
};

export const isInternalFeatureAccess = (
  featureAccess: string | null | undefined
): boolean =>
  ['dev', 'admin', 'also_admin'].includes((featureAccess ?? '').toLowerCase());

/** Compare a semver-style version string against a major.minor threshold */
export function isVersionAtLeast(
  version: string,
  major: number,
  minor: number
) {
  const [maj, min] = version.split('.').map(Number);
  return maj > major || (maj === major && (min ?? 0) >= minor);
}
